import { FC, useMemo } from "react";
import billingsTranslationsHelper from "../../../../../languages/billings-translations.helper";
import CardComponent from "../../../../../common/components/card/card.component";
import TableComponent from "../../../../../common/components/table/table.component";
import BillingFormData from "../types/billing-form.data";
import BillingRouteDetailsTableRow from "./types/billing-route-details-table-row";
import billingRouteDetailsHelper from "./billing-route-details.helper";

type BillingRouteDetailsProps = {
  billingData: BillingFormData | undefined;
};

const BillingRouteDetailsComponent: FC<BillingRouteDetailsProps> = (props) => {
  const createTableRow = (
    billingData: BillingFormData
  ): BillingRouteDetailsTableRow => {
    const amountForDistance =
      billingData.distance * billingData.contractDetails!.distanceRate;

    return {
      id: billingData.internalOrderId.toString(),
      value: {
        distance: (
          <div title={billingData.distance?.toString()}>
            {billingData.distance} KM
          </div>
        ),
        rateForDistance: (
          <div title={billingData.contractDetails?.distanceRate?.toString()}>
            {billingData.contractDetails?.distanceRate?.toFixed(2)} PLN
          </div>
        ),
        amountForDistance: (
          <div title={amountForDistance.toString()}>
            {amountForDistance.toFixed(2)} PLN
          </div>
        ),
        amountForChargeHaltings: (
          <div title={billingData.amountForChargeHaltings.toString()}>
            {billingData.amountForChargeHaltings?.toFixed(2)} PLN
          </div>
        ),
        amountForChargeHighways: (
          <div title={billingData.amountForChargeHighways.toString()}>
            {billingData.amountForChargeHighways?.toFixed(2)} PLN
          </div>
        ),
      },
    };
  };

  const tableColumns = billingRouteDetailsHelper.getTableColumns();

  const tableRows: BillingRouteDetailsTableRow[] = useMemo(() => {
    if (props.billingData) {
      var tableRow = createTableRow(props.billingData);
      return [tableRow];
    }

    return [];
  }, [props.billingData]);

  const translations = billingsTranslationsHelper.getRouteSummaryTranslations();

  return (
    <CardComponent
      classNames={{ root: "billing_route_details" }}
      header={{ title: translations.summaryLabel }}
    >
      <TableComponent columns={tableColumns} rows={tableRows} />
    </CardComponent>
  );
};

export default BillingRouteDetailsComponent;
